// extracted by css-extract-rspack-plugin
export default {"cls1":"Upsell-cls1__GX","cls2":"Upsell-cls2_yDv Upsell-cls1__GX"};